import { render, staticRenderFns } from "./LabelEditor.vue?vue&type=template&id=530f3180&"
import script from "./LabelEditor.vue?vue&type=script&lang=js&"
export * from "./LabelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports